import axios from 'axios';
import api from '../apis/constants';

export interface UploadResponse {
  status: string;
  data: {
    file: {
      url: string;
      fileName: string;
      filePath: string;
      mimeType: string;
      size: number;
    }
  }
}

export interface MultipleUploadResponse {
  success: boolean;
  data: {
    urls: string[];
    filenames: string[];
  };
}

export interface DeleteFileResponse {
  status: string;
  message: string;
}

export const uploadSingleFile = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post(`/upload/single`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const uploadMultipleFiles = async (files: File[]): Promise<MultipleUploadResponse> => {
  const formData = new FormData();
  
  files.forEach((file) => {
    formData.append('files', file);
  });

  const response = await api.post(`/upload/multiple`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const deleteFileByUrl = async (url: string): Promise<DeleteFileResponse> => {
  try {
    const response = await api.delete('/upload/delete-by-url', {
      data: { url }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting file:', error);
    return {
      status: 'error',
      message: 'Failed to delete file'
    }
  }
}; 